import { render, staticRenderFns } from "./AreaAuthMgrPage.vue?vue&type=template&id=14827037&scoped=true&"
import script from "./AreaAuthMgrPage.vue?vue&type=script&lang=js&"
export * from "./AreaAuthMgrPage.vue?vue&type=script&lang=js&"
import style0 from "./AreaAuthMgrPage.vue?vue&type=style&index=0&id=14827037&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14827037",
  null
  
)

export default component.exports